<template>
  <v-card>
    <v-card-title>
      <span>{{ $t('MESSAGE.REALLY_WANT_TO_REMOVE') }}</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-layout align-center justify-space-between row>
          <v-btn outlined text @click="cancel">{{ $t('BUTTON.CANCEL') }}</v-btn>
          <v-btn color="error" :loading="isLoading" @click="remove">{{
            $t('BUTTON.DELETE')
          }}</v-btn>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'DocumentsDelete',

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  computed: {
    isLoading() {
      return this.$store.getters['loading'];
    }
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    remove() {
      this.$store
        .dispatch('document/remove', {
          document_id: this.id
        })
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('success', data);
        });
    }
  }
};
</script>
